// @ts-nocheck
import * as actions from './dynamicPagesActions';
import reducer from './dynamicPagesReducer';
import * as selectors from './dynamicPagesSelectors';

export { actions, reducer, selectors };
